export default function rowResize(e, prefix) {
    if (this.dataGet(prefix+'/openFilterData') != null) {
        this.dataSet(prefix+'/openFilterData/open', false);
    }
    const th = e.target.closest('.newListViewHeaderCell');
    const table = e.target.closest('.newListView');
    const index = Array.from(th.parentNode.childNodes).indexOf(th);
    const lockedColumns = this.dataGet(prefix+'/lockedColumns');

    // get parent parent class name
    const parentClass = th.parentNode.parentNode.className;
    let linesRow = table.querySelector('.newListViewLines').children[index];

    if (lockedColumns && !parentClass.includes('lockedColumns')) {
        linesRow = table.querySelector('.scrollableColumnsLines').children[index];
    } else if (lockedColumns) {
        linesRow = table.querySelector('.lockedColumnsLines').children[index];
    }

    const width = th.clientWidth;

    this.index = index;
    this.resizeStart = e.clientX;
    this.resizeWidthStart = width;
    this.resizeRows = [th, linesRow];
    this.activeResizeRow = true;
}
